module.exports = __webpack_public_path__ + "img/03.c38f55b2.jpg";